import { render, staticRenderFns } from "./UtilPanelContent.vue?vue&type=template&id=3b991fc2"
import script from "./UtilPanelContent.vue?vue&type=script&lang=js"
export * from "./UtilPanelContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports